<template>
	<BaseInput ref="BaseInput" v-model="model" v-bind="$attrs" v-on="$listeners">
		<template #bottom>
			<div class="h-48 min-w-48 overflow-y-scroll absolute bg-white z-50 border rounded" v-if="options && options.length">
				<div
					v-for="option in options"
					:key="option"
					class="cursor-pointer hover:bg-connectProBlue hover:text-white p-2"
					@mousedown="updateValue(option)"
				>
					{{ option }}
				</div>
			</div>
		</template>
	</BaseInput>
</template>

<script>
import BaseInput from '@/components/forms/inputs/BaseInput';
import Validate from '@/mixins/Validate';

export default {
	name: 'AutocompleteInput',
	components: { BaseInput },
	mixins: [Validate],
	props: {
		options: { required: true },
		value: {},
	},
	methods: {
		updateValue(value) {
			this.model = value;
			this.$emit('selectValue', value);
		},
	},
	computed: {
		model: {
			get() {
				return this.value;
			},
			set(v) {
				this.$emit('input', v);
			},
		},
	},
};
</script>
